var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fill-height"},[_c('MessageService'),(_vm.$route.meta.noLayout)?_c('AppNoLayout'):_c('AppLayout')],1)}
var staticRenderFns = []

export { render, staticRenderFns }